import { HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, finalize, retry } from 'rxjs/operators';
import { environment } from "../environments/environment";

export const sessionInterceptorFn: HttpInterceptorFn = (req, next) => {

  console.log("session has started");
  const appId = environment.msalConfig.auth.clientId;

  const sessionReq = req.clone({
    setHeaders: {
      'X-Session-Id': `${appId}`
    }
  });

  return next(sessionReq);

};
